import { gql } from '@apollo/client';

export const ProjectPerAccountingExpenseFragment = gql`
  fragment ProjectPerAccountingExpense on ProjectPerAccountingExpense {
    id
    rdProjectId
    allocationPercentNotRounded
  }
`;
